export default __webpack_public_path__ + "static/media/FogueteKahshStoreWeb.bd471ce7.png";